export let data = [
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-7bac-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1206642,
    loc: "",
    uuid: "acecac60-c6ed-012f-610a-58d385a7bc34",
    artist: "Miller, Kelly",
    year: "1914-1918",
    location: "Washington D.C.",
    description: "Woman smiles while pushing a wheelbarrow of wood",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 25,
    activityScore3: 26,
    activityScore4: 27,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1206642&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f8bb-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260019,
    loc: "",
    uuid: "0b8d5580-c613-012f-a285-58d385a7bc34",
    artist: "Mydans, Carl",
    year: 1935,
    location: "Washington D.C.",
    description: "Woman pumps water from slum well",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 11,
    activityScore2: 23,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260019&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/75ece515-a29d-388d-e040-e00a180601f1",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1800851,
    loc: "",
    uuid: "df37bc10-c6e8-012f-9d24-3c075448cc4b",
    artist: "Grossman, Sid",
    year: 1939,
    location: "W. 125th and 8th, Harlem, New York",
    description: "Woman crossing street in Harlem",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 13,
    activityScore2: 23,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1800851&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/8fbb4d50-461d-0134-7795-00505686a51c",
    collection: "Schomburg Center for Research in Black Culture",
    id: 56806338,
    loc: "",
    uuid: "b8eee320-1ab6-0134-f291-00505686a51c",
    artist: "",
    year: 1937,
    location: "Harlem, New York",
    description: "Woman passes Harlem dry cleaners",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 23,
    activityScore2: 24,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=56806338&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/7e2d3c79-994e-d1b2-e040-e00a18064cca",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1818757,
    loc: "",
    uuid: "93a77360-c6ce-012f-0f1d-58d385a7bc34",
    artist: "",
    year: 1938,
    location: "Lincoln School for Nurses, New York",
    description: "Two nurses change a patient's dressings",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 12,
    activityScore3: 29,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1818757&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/7e2d3c79-9950-d1b2-e040-e00a18064cca",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1818759,
    loc: "",
    uuid: "94228c00-c6ce-012f-0278-58d385a7bc34",
    artist: "Staudinger Rozaffy, R.",
    year: 1939,
    location: "Lincoln School for Nurses, New York",
    description: "Three nurses exit building",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 12,
    activityScore3: 26,
    activityScore4: 29,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1818759&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/7e2d3c79-9944-d1b2-e040-e00a18064cca",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1818747,
    loc: "",
    uuid: "9148f820-c6ce-012f-d4ff-58d385a7bc34",
    artist: "",
    year: 1959,
    location: "Lincoln School for Nurses, New York",
    description: "Nursing students sitting on steps of Lincoln School",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 12,
    activityScore3: 15,
    activityScore4: 26,
    activityScore5: 29,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1818747&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f88c-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1259992,
    loc: "",
    uuid: "919ab9d0-c612-012f-e31b-58d385a7bc34",
    artist: "Wolcott, Marion Post",
    year: 1941,
    location: "Okeechobee Camp, Belle Glade, Florida",
    description: "Woman with children washing food by water pump",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 22,
    activityScore3: 30,
    activityScore4: 37,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1259992&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-8431-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1213442,
    loc: "",
    uuid: "3ea0a8b0-c6d1-012f-001d-58d385a7bc34",
    artist: "Smith, Roger",
    year: "1939-1945",
    location: "",
    description: "Woman grocery shops with her children",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 14,
    activityScore3: 22,
    activityScore4: 23,
    activityScore5: 26,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1213442&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/b6e69fe8-7bf8-05aa-e040-e00a18062cd5",
    collection: "Schomburg Center for Research in Black Culture",
    id: 3990809,
    loc: "",
    uuid: "345003e0-c62a-012f-ff6f-58d385a7bc34",
    artist: "",
    year: "",
    location: "Harlem, New York",
    description: "Family visits Park Avenue Market in Harlem",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 13,
    activityScore3: 15,
    activityScore4: 22,
    activityScore5: 23,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=3990809&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f9fb-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260330,
    loc: "",
    uuid: "b9e86aa0-c645-012f-68b6-58d385a7bc34",
    artist: "",
    year: 1946,
    location: "Staten Island, New York",
    description: "6888th Women's Army Corp arrive in New York from Europe",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 26,
    activityScore3: 28,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260330&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa3e-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260396,
    loc: "",
    uuid: "388e6340-c6d1-012f-3f18-58d385a7bc34",
    artist: "Smith, Roger",
    year: "1939-1945",
    location: "Rose Garden, Botanical Gardens, Washington D.C.",
    description: "Women landscaping Botanical Gardens",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 25,
    activityScore3: 27,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260396&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f8b9-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260017,
    loc: "",
    uuid: "097578a0-c613-012f-a5a3-58d385a7bc34",
    artist: "Collins, Marjory",
    year: "1939-1945",
    location: "Potomac Park, Washington D.C.",
    description: "Woman and girls cycle through Potomac Park",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 13,
    activityScore2: 15,
    activityScore3: 22,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260017&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/85108dd0-461d-0134-09ad-00505686a51c",
    collection: "Schomburg Center for Research in Black Culture",
    id: 56806324,
    loc: "",
    uuid: "22d46120-13cf-0134-cb11-00505686a51c",
    artist: "",
    year: "1935-1939",
    location: "Harlem, New York",
    description: "Women sitting in front of an empty store in Harlem",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 23,
    activityScore2: 24,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=56806324&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/c1fcc19f-33b5-c09d-e040-e00a18061e66",
    collection: "Schomburg Center for Research in Black Culture",
    id: 4042602,
    loc: "",
    uuid: "7f724b90-c5f2-012f-7f0c-58d385a7bc34",
    artist: "Roberts, G. Walter",
    year: "1890-1899",
    location: "",
    description: "Woman dressed in men's clothing",
    landscape: 1,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 14,
    activityScore2: 26,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=4042602&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-1d45-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1169404,
    loc: "",
    uuid: "9276af80-c6b3-012f-8e67-3c075448cc4b",
    artist: "Olcott, Jane",
    year: "1914-1918",
    location: "New York, New York",
    description: "Group of girls practicing Reserve drills",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 22,
    activityScore2: 26,
    activityScore3: 28,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1169404&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-1d41-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1169400,
    loc: "",
    uuid: "86509440-c6b3-012f-1a8c-3c075448cc4b",
    artist: "Olcott, Jane",
    year: "1914-1918",
    location: "New York, New York",
    description: "Woman poses while playing tennis",
    landscape: 1,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 15,
    activityScore2: 26,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1169400&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47dd-e887-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1240248,
    loc: "",
    uuid: "271673d0-c62a-012f-c3b2-58d385a7bc34",
    artist: "Fuller, Thomas Oscar",
    year: 1910,
    location: "Nashville, Tennessee",
    description: "Members of Women's Bible Training Class pose for portrait",
    landscape: 1,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 13,
    activityScore3: 26,
    activityScore4: 33,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1240248&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/926d9ec0-9f93-0134-a6c2-00505686a51c",
    collection: "Schomburg Center for Research in Black Culture",
    id: 56997665,
    loc: "",
    uuid: "fe4b89c0-9ba4-0134-eb49-00505686a51c",
    artist: "",
    year: 1916,
    location: "New York, New York",
    description: "Group Portrait Lincoln School for Nurses",
    landscape: 1,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 26,
    activityScore3: 29,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=56997665&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-1d0f-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1168490,
    loc: "",
    uuid: "3b71aa70-c6ba-012f-84d2-3c075448cc4b",
    artist: "",
    year: 1905,
    location: "New York, New York",
    description: "Woman and ten children standing on stoop of apartment",
    landscape: 1,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 22,
    activityScore3: 26,
    activityScore4: 35,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1168490&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-1ef2-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1217218,
    loc: "",
    uuid: "fbd008b0-c6f3-012f-88bd-58d385a7bc34",
    artist: "Chicago Commission on Race Relations",
    year: 1922,
    location: "Chicago, Illinois",
    description: "Woman holding infant and milk bottle",
    landscape: 1,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 22,
    activityScore3: 30,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1217218&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-8175-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1211916,
    loc: "",
    uuid: "86005380-c612-012f-3b53-58d385a7bc34",
    artist: "Lange, Dorothea",
    year: 1937,
    location: "Memphis, Tennessee",
    description: "Women traveling from Tennessee to Arkansas",
    landscape: 1,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 36,
    activityScore3: 37,
    activityScore4: 38,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1211916&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-7bdd-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1206691,
    loc: "",
    uuid: "bf73d3b0-c6ed-012f-973c-58d385a7bc34",
    artist: "Miller, Kelly",
    year: "1914-1918",
    location: "Washington D.C.",
    description: "Portrait of women employed by the Navy",
    landscape: 1,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 25,
    activityScore3: 26,
    activityScore4: 28,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1206691&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47dd-df8d-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1121215,
    loc: "",
    uuid: "5c3770f0-c617-012f-b50a-58d385a7bc34",
    artist: "Whipple, Phila M.",
    year: 1907,
    location: "Boston",
    description: "Family posing outside their cabin home",
    landscape: 1,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 22,
    activityScore2: 26,
    activityScore3: 33,
    activityScore4: 35,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1121215&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa22-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260373,
    loc: "",
    uuid: "1d520180-c6be-012f-bf75-58d385a7bc34",
    artist: "Leonard",
    year: 1937,
    location: "Freedman's Hospital, Washington D.C.",
    description: "Student preparing surgical dressings",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 9,
    activityScore2: 12,
    activityScore3: 26,
    activityScore4: 29,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260373&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa45-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260399,
    loc: "",
    uuid: "3915beb0-c6d1-012f-f033-58d385a7bc34",
    artist: "Smith, Roger",
    year: "1939-1945",
    location: "Washington D.C.",
    description: "War industry training for public school woman",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 9,
    activityScore2: 10,
    activityScore3: 25,
    activityScore4: 32,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260399&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f992-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260226,
    loc: "",
    uuid: "a7095240-c612-012f-12b2-58d385a7bc34",
    artist: "Lee, Russell",
    year: "1940-1949",
    location: "Chicago, Illinois",
    description: "Woman reading bible in Store Front Baptist church, Chicago",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 9,
    activityScore2: 13,
    activityScore3: 21,
    activityScore4: 26,
    activityScore5: 33,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260226&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa1b-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260367,
    loc: "",
    uuid: "1aabcb00-c6be-012f-b609-58d385a7bc34",
    artist: "",
    year: "1935-1943",
    location: "Brooklyn, New York",
    description: "Woman working at Brooklyn Work Experience Center",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 25,
    activityScore4: 26,
    activityScore5: 32,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260367&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa3f-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260397,
    loc: "",
    uuid: "362e0040-c6d1-012f-a9ee-58d385a7bc34",
    artist: "Joseph, E.F.",
    year: 1943,
    location: "Kaiser Shipyards, Richmond, California",
    description: "Industrial worker building SS George Washington Carver",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 25,
    activityScore4: 28,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260397&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa43-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260392,
    loc: "",
    uuid: "1f523b30-c6be-012f-3d1f-58d385a7bc34",
    artist: "",
    year: "1939-1950",
    location: "Brooklyn, New York",
    description: "Young woman working at Brooklyn Work Experience Center",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 24,
    activityScore4: 32,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260392&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa41-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260391,
    loc: "",
    uuid: "1eeb10a0-c6be-012f-58dd-58d385a7bc34",
    artist: "",
    year: "1939-1950",
    location: "",
    description: "Young woman metalworking",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 24,
    activityScore4: 32,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260391&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-8410-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1212151,
    loc: "",
    uuid: "24641520-c6d1-012f-59b4-58d385a7bc34",
    artist: "",
    year: "",
    location: "Richmond, California",
    description: "Woman icing cake for domestic employer employer",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 11,
    activityScore2: 12,
    activityScore3: 30,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1212151&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-a082-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1232074,
    loc: "",
    uuid: "037643c0-c6bc-012f-0577-58d385a7bc34",
    artist: "",
    year: 1908,
    location: "Atlanta, Georgia",
    description: "Woman working as a typesetter in Atlanta",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 24,
    activityScore3: 26,
    activityScore4: 32,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1232074&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa33-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260383,
    loc: "",
    uuid: "23acdbc0-c6be-012f-2e36-58d385a7bc34",
    artist: "",
    year: 1939,
    location: "Mercy Hospital, New York",
    description: "Young woman typing at Mercy Hospital",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 26,
    activityScore3: 27,
    activityScore4: 29,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260383&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa4d-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260404,
    loc: "",
    uuid: "3cbdaf50-c6d1-012f-fe3f-58d385a7bc34",
    artist: "Liberman, Howard",
    year: 1942,
    location: "Philadelphia, Pensylvania",
    description: "Woman sews army jackets",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 25,
    activityScore4: 26,
    activityScore5: 28,
    activityScore6: 33,
    imageLink: "https://images.nypl.org/index.php?id=1260404&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa18-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260364,
    loc: "",
    uuid: "18f4e240-c6be-012f-5ce3-58d385a7bc34",
    artist: "",
    year: "1926-1950",
    location: "New York, New York",
    description: "Woman performing Kline tests at Bureau of Social Hygiene",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 26,
    activityScore3: 27,
    activityScore4: 29,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260364&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/6bdb1562-8189-8f7e-e040-e00a18067399",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1702766,
    loc: "",
    uuid: "3fec47b0-c6d1-012f-1ef7-58d385a7bc34",
    artist: "",
    year: "1930-1945",
    location: "",
    description: "Woman cleaning Civil Office building",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 24,
    activityScore3: 27,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1702766&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa25-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260376,
    loc: "",
    uuid: "20cce780-c6be-012f-e956-58d385a7bc34",
    artist: "",
    year: "1935-1943",
    location: "New York, New York",
    description: "Woman pouring coffee",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 26,
    activityScore3: 30,
    activityScore4: 34,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260376&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-1ca9-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1168373,
    loc: "",
    uuid: "425dec40-c6e7-012f-dd02-3c075448cc4b",
    artist: "",
    year: 1902,
    location: "St. Louis, Missouri",
    description: "Home Economics class at Summer High School, St. Louis",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 11,
    activityScore3: 30,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1168373&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/7e2d3c79-994a-d1b2-e040-e00a18064cca",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1818753,
    loc: "",
    uuid: "92ba9260-c6ce-012f-6cf2-58d385a7bc34",
    artist: "",
    year: 1914,
    location: "Lincoln School for Nurses, New York",
    description: "Nursing students in Lincoln lounge",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 12,
    activityScore3: 15,
    activityScore4: 18,
    activityScore5: 26,
    activityScore6: 29,
    imageLink: "https://images.nypl.org/index.php?id=1818753&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/7e2d3c79-9941-d1b2-e040-e00a18064cca",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1818744,
    loc: "",
    uuid: "908f84d0-c6ce-012f-706e-58d385a7bc34",
    artist: "",
    year: 1929,
    location: "Lincoln School for Nurses, New York",
    description: "Five nursing students in laboratory",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 12,
    activityScore3: 26,
    activityScore4: 29,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1818744&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/7e2d3c79-994c-d1b2-e040-e00a18064cca",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1818755,
    loc: "",
    uuid: "932cecf0-c6ce-012f-29d0-58d385a7bc34",
    artist: "",
    year: 1931,
    location: "Lincoln School for Nurses, New York",
    description: "Nursing students in Science laboratory",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 12,
    activityScore3: 29,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1818755&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/7e2d3c79-994b-d1b2-e040-e00a18064cca",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1818754,
    loc: "",
    uuid: "92f68f20-c6ce-012f-eaf0-58d385a7bc34",
    artist: "",
    year: 1931,
    location: "Lincoln School for Nurses, New York",
    description: "Nursing students in Lincoln library",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 12,
    activityScore3: 29,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1818754&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/7e2d3c79-994d-d1b2-e040-e00a18064cca",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1818756,
    loc: "",
    uuid: "93712fa0-c6ce-012f-e77d-58d385a7bc34",
    artist: "",
    year: 1938,
    location: "Lincoln School for Nurses, New York",
    description: "Nursing students in Lincoln library",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 12,
    activityScore3: 29,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1818756&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa60-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260413,
    loc: "",
    uuid: "9ee93e70-c6b2-012f-587f-58d385a7bc34",
    artist: "Liberman, Howard",
    year: 1942,
    location: "Roanoke, Virginia",
    description: "Teacher educating children on war-time scrap collection",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 12,
    activityScore3: 13,
    activityScore4: 22,
    activityScore5: 25,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260413&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/7e2d3c79-9951-d1b2-e040-e00a18064cca",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1818760,
    loc: "",
    uuid: "946f4680-c6ce-012f-a71e-58d385a7bc34",
    artist: "",
    year: "1960-1960",
    location: "Lincoln School for Nurses, New York",
    description: "Annual Lincoln School Luncheon",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 12,
    activityScore3: 13,
    activityScore4: 26,
    activityScore5: 29,
    activityScore6: 33,
    imageLink: "https://images.nypl.org/index.php?id=1818760&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47dd-c69e-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1206635,
    loc: "",
    uuid: "36a3bde0-c6d1-012f-1fc8-58d385a7bc34",
    artist: "Joseph, E.F.",
    year: 1943,
    location: "Kaiser Shipyards, Richmond, California",
    description: "Industrial workers building SS George Washington Carver",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 25,
    activityScore4: 29,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1206635&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f98e-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260222,
    loc: "",
    uuid: "a513b4e0-c612-012f-cd26-58d385a7bc34",
    artist: "Lee, Russell",
    year: "1950-1959",
    location: "Good Shepard Community Center, Chicago, Illinois",
    description: "Women of the National Youth Adminstration meet in Chicago",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 13,
    activityScore3: 26,
    activityScore4: 31,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260222&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa4e-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260405,
    loc: "",
    uuid: "3724ad80-c6d1-012f-e685-58d385a7bc34",
    artist: "Joseph, E.F.",
    year: 1943,
    location: "Kaiser Shipyards, Richmond, California",
    description: "Industrial workers building SS George Washington Carver",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 25,
    activityScore4: 28,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260405&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa3a-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260387,
    loc: "",
    uuid: "1b1bfd40-c6be-012f-8075-58d385a7bc34",
    artist: "",
    year: "1940-1949",
    location: "",
    description: "Young woman demonstrates tool operations",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260387&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-1f1a-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1217255,
    loc: "",
    uuid: "0ad98790-c6f4-012f-2902-58d385a7bc34",
    artist: "Chicago Commission on Race Relations",
    year: 1922,
    location: "Chicago, Illinois",
    description: "Women working machinery in apron factory",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 12,
    activityScore3: 20,
    activityScore4: 24,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1217255&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f8b0-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260020,
    loc: "",
    uuid: "0609f6e0-c613-012f-46ae-58d385a7bc34",
    artist: "Rothstein, Arthur",
    year: 1937,
    location: "Washington D.C.",
    description: "Woman and child in slum kitchen",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 14,
    activityScore3: 22,
    activityScore4: 30,
    activityScore5: 35,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260020&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f90f-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260095,
    loc: "",
    uuid: "a181cf30-c612-012f-e613-58d385a7bc34",
    artist: "Wolcott, Marion Post",
    year: 1939,
    location: "Atlanta, Georgia",
    description: "Woman working as nanny feeds child",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 12,
    activityScore3: 22,
    activityScore4: 26,
    activityScore5: 30,
    activityScore6: 35,
    imageLink: "https://images.nypl.org/index.php?id=1260095&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f906-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260085,
    loc: "",
    uuid: "00431050-c613-012f-5a9f-58d385a7bc34",
    artist: "Vachon, John",
    year: 1940,
    location: "Norfolk, Virginia",
    description: "Woman and children in their Virginia home",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 14,
    activityScore3: 22,
    activityScore4: 26,
    activityScore5: 35,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260085&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-8176-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1211917,
    loc: "",
    uuid: "aa933840-c612-012f-53e8-58d385a7bc34",
    artist: "Lee, Russell",
    year: 1941,
    location: "Chicago, Illinois",
    description: "Woman and children in Chicago apartment",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 14,
    activityScore3: 22,
    activityScore4: 35,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1211917&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa49-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260394,
    loc: "",
    uuid: "2127b3a0-c6be-012f-bba4-58d385a7bc34",
    artist: "",
    year: "1930-1959",
    location: "Long Island, New York",
    description: "Women operate a food mixer",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 12,
    activityScore3: 26,
    activityScore4: 30,
    activityScore5: 32,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260394&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-1ce2-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1210426,
    loc: "",
    uuid: "334c31f0-c6bb-012f-a2ec-3c075448cc4b",
    artist: "Washington, Booker T.",
    year: 1906,
    location: "Tuskegee, Alabama",
    description: "Millinery class at Tuskegee Institute",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 26,
    activityScore4: 32,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1210426&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-1f1b-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1217256,
    loc: "",
    uuid: "0b43ccf0-c6f4-012f-7162-58d385a7bc34",
    artist: "Chicago Commission on Race Relations",
    year: 1922,
    location: "Chicago, Illinois",
    description: "Women and girls working in a milliner factory",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 22,
    activityScore4: 24,
    activityScore5: 26,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1217256&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-1f19-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1217254,
    loc: "",
    uuid: "0a656cc0-c6f4-012f-4f02-58d385a7bc34",
    artist: "Chicago Commission on Race Relations",
    year: 1922,
    location: "Chicago, Illinois",
    description: "Women and girls working in lampshade factory",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 22,
    activityScore4: 24,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1217254&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/84cbff90-a7ca-0131-6533-58d385a7b928",
    collection: "Schomburg Center for Research in Black Culture",
    id: 5114784,
    loc: "",
    uuid: "6d16f100-997d-0131-f800-58d385a7b928",
    artist: "",
    year: 1954,
    location: "Brooklyn, New York",
    description: "Women wait for the Miss Rheingold pageant contestants",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 15,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=5114784&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-1d44-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1169403,
    loc: "",
    uuid: "8f86d270-c6b3-012f-0390-3c075448cc4b",
    artist: "Olcott, Jane",
    year: "1914-1918",
    location: "New York, New York",
    description: "Women working in a garment factory during WWI",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 25,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1169403&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa48-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260393,
    loc: "",
    uuid: "1fbe4430-c6be-012f-23e9-58d385a7bc34",
    artist: "",
    year: "1920-1939",
    location: "Chicago, Illinois",
    description: "Women work as Clerks at South Parkway Y.W.C.A., Chicago",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 13,
    activityScore3: 26,
    activityScore4: 27,
    activityScore5: 32,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260393&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa1c-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260368,
    loc: "",
    uuid: "1b821cb0-c6be-012f-638a-58d385a7bc34",
    artist: "Eagle, Arnold",
    year: "1935-1943",
    location: "Astoria, New York",
    description: "Women sewing at Astoria Work Experience Center",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 32,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260368&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa19-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260366,
    loc: "",
    uuid: "1a2338e0-c6be-012f-bf35-58d385a7bc34",
    artist: "",
    year: "1935-1943",
    location: "Astoria, New York",
    description: "Woman supervising sewing",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: 32,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260366&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa28-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260378,
    loc: "",
    uuid: "21ea5a70-c6be-012f-99f7-58d385a7bc34",
    artist: "Eagle, Arnold",
    year: "1935-1943",
    location: "New York, New York",
    description: "Three women at radio workshop",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 13,
    activityScore3: 18,
    activityScore4: 26,
    activityScore5: 27,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260378&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa21-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260372,
    loc: "",
    uuid: "1cf298b0-c6be-012f-ea03-58d385a7bc34",
    artist: "",
    year: "1935-1943",
    location: "",
    description: "Nurses' aid feeds infant",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 22,
    activityScore3: 26,
    activityScore4: 27,
    activityScore5: 29,
    activityScore6: 32,
    imageLink: "https://images.nypl.org/index.php?id=1260372&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa1e-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260369,
    loc: "",
    uuid: "bd7b9a0-c6be-012f-13bb-58d385a7bc34",
    artist: "",
    year: "1935-1943",
    location: "Astoria, New York",
    description: "Women sewing at Astoria Work Experience Center",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 32,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260369&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-8413-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1213443,
    loc: "",
    uuid: "3d439de0-c6d1-012f-9d22-58d385a7bc34",
    artist: "United States Army Signal Corp.",
    year: "1939-1945",
    location: "Jersey City, New Jersey",
    description: "Women in the Repair Depot repair military clothing",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 25,
    activityScore4: 26,
    activityScore5: 28,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1213443&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f990-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260224,
    loc: "",
    uuid: "a60329d0-c612-012f-d814-58d385a7bc34",
    artist: "Lee, Russell",
    year: "1940-1949",
    location: "Chicago, Illinois",
    description: "Women working as insurance clerks",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 24,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260224&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-8728-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1212143,
    loc: "",
    uuid: "aa1fc610-c612-012f-447c-58d385a7bc34",
    artist: "Lee, Russell",
    year: 1941,
    location: "Chicago, Illinois",
    description: "Congregation of Store Front Baptist Church, Chicago",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 13,
    activityScore2: 21,
    activityScore3: 26,
    activityScore4: 33,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1212143&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/79c17ca1-7a0b-103e-e040-e00a18067ff9",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1806595,
    loc: "",
    uuid: "d5b40110-c628-012f-32ce-58d385a7bc34",
    artist: "Holt, Norma",
    year: 1953,
    location: "State Board of Pardons and Parole, Georgie",
    description: "Women await Rosa Lee's parole hearing in Georgia",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 13,
    activityScore2: 27,
    activityScore3: 31,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1806595&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/7b07ea5c-6223-6b59-e040-e00a18065a4d",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1811321,
    loc: "",
    uuid: "303a6f20-c62a-012f-6e74-58d385a7bc34",
    artist: "",
    year: "1920-1929",
    location: "",
    description: "Group of Women sit at Restaurant counter",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 13,
    activityScore2: 15,
    activityScore3: 26,
    activityScore4: 34,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1811321&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-1d46-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1169405,
    loc: "",
    uuid: "9b707e10-c6b3-012f-8190-3c075448cc4b",
    artist: "Olcott, Jane",
    year: "1914-1918",
    location: "New York, New York",
    description: "Group of women leisurely reading",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 14,
    activityScore2: 15,
    activityScore3: 25,
    activityScore4: 26,
    activityScore5: 35,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1169405&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f98f-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260223,
    loc: "",
    uuid: "a5850260-c612-012f-c3eb-58d385a7bc34",
    artist: "Lee, Russell",
    year: "1950-1959",
    location: "Chicago, Illinois",
    description: "Young women play violin and piano",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 14,
    activityScore2: 15,
    activityScore3: 18,
    activityScore4: 22,
    activityScore5: 26,
    activityScore6: 35,
    imageLink: "https://images.nypl.org/index.php?id=1260223&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-842f-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1213441,
    loc: "",
    uuid: "3b722300-c6d1-012f-7aba-58d385a7bc34",
    artist: "Smith, Roger",
    year: "1942-1943",
    location: "Lucy D. Slowe Residence Hall, Washington D.C.",
    description: "Women play cards in their residence",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 14,
    activityScore2: 15,
    activityScore3: 25,
    activityScore4: 26,
    activityScore5: 35,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1213441&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-1d43-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1169402,
    loc: "",
    uuid: "8c790dd0-c6b3-012f-f157-3c075448cc4b",
    artist: "Olcott, Jane",
    year: "1914-1918",
    location: "New York, New York",
    description: "Women in pottery class",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 20,
    activityScore2: 25,
    activityScore3: 32,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1169402&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-8729-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1212144,
    loc: "",
    uuid: "ab1f1840-c612-012f-3660-58d385a7bc34",
    artist: "Lee, Russell",
    year: 1941,
    location: "South Side Chicago, Illinois",
    description: "Woman launders clothes in Chicago apartment",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 11,
    activityScore: 14,
    activityScore2: 26,
    activityScore3: 35,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1212144&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-1f2d-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1216585,
    loc: "",
    uuid: "78009f80-c6da-012f-cf07-3c075448cc4b",
    artist: "",
    year: 1916,
    location: "Philadelphia, Pensylvania",
    description:
      "Portrait of a high school teacher wearing broach and hair comb",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 9,
    activityScore2: 12,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1216585&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-1ce8-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1210432,
    loc: "",
    uuid: "454b6580-c6bb-012f-95b5-3c075448cc4b",
    artist: "Washington, Booker T.",
    year: 1906,
    location: "Tuskegee, Alabama",
    description:
      "Woman from Tuskegee Institute demonstrates how to set a table",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 11,
    activityScore2: 26,
    activityScore3: 30,
    activityScore4: 32,
    activityScore5: 35,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1210432&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e2-ed3e-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "05schaw",
    loc: "",
    uuid: "6f6c7a20-c6b6-012f-94ec-58d385a7bc34",
    artist: "",
    year: "1880-1889",
    location: "",
    description: "Portrait of woman in black lace dress",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 11,
    activityScore2: 26,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=05schaw&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/6bdb1562-818b-8f7e-e040-e00a18067399",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1702768,
    loc: "",
    uuid: "409f6160-c6d1-012f-d5b3-58d385a7bc34",
    artist: "",
    year: "1900-1935",
    location: "Mound Bayou, Mississippi",
    description: "Telephone operator",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 24,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1702768&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/1292ebb0-3bc8-0134-6c19-00505686a51c",
    collection: "Schomburg Center for Research in Black Culture",
    id: 56806342,
    loc: "",
    uuid: "fc0cadc0-3b16-0134-2fe3-00505686a51c",
    artist: "",
    year: "1935-1943",
    location: "",
    description: "Portrait of woman in floral costume",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 16,
    activityScore3: 17,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=56806342&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f9c8-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260279,
    loc: "",
    uuid: "ae87ea20-c645-012f-8c54-58d385a7bc34",
    artist: "",
    year: 1948,
    location: "Tokyo, Japan",
    description: "Woman poses with Japanese doll in Tokyo",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 15,
    activityScore2: 26,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260279&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdce-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "59SCCDV",
    loc: "",
    uuid: "c7021a60-c6ca-012f-cd71-58d385a7bc34",
    artist: "Morse, George Daniels",
    year: "1880-1889",
    location: "San Francisco, California",
    description: "Portrait of a woman wearing glasses and cross earrings",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 21,
    activityScore2: 26,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=59SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-1f56-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1216626,
    loc: "",
    uuid: "f9722f20-c6da-012f-6c1e-3c075448cc4b",
    artist: "",
    year: 1916,
    location: "Philadelphia, Pensylvania",
    description: "Portrait of a girl with long hair in a white blouse",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 22,
    activityScore2: 26,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1216626&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdc3-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "49SCCDV",
    loc: "",
    uuid: "c30fbab0-c6ca-012f-305c-58d385a7bc34",
    artist: "Bill, C.K.",
    year: 1860,
    location: "",
    description: "Portrait of a woman holding a bonnet",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: 33,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=49SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-fd15-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "03SCCAB",
    loc: "",
    uuid: "071b57b0-c6e0-012f-a107-58d385a7bc34",
    artist: "",
    year: 1875,
    location: "",
    description: "Portrait of a woman wearing a hat and bustle",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=03SCCAB&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-fd21-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "16SCCAB",
    loc: "",
    uuid: "0ce634c0-c6e0-012f-54b5-58d385a7bc34",
    artist: "Benjamin, O.C.",
    year: 1880,
    location: "New Jersey",
    description: "Portrait of a woman wearing a velvet coat",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=16SCCAB&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-fd2c-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "28SCCAB",
    loc: "",
    uuid: "12bafc10-c6e0-012f-15a5-58d385a7bc34",
    artist: "Stanton & Burdick",
    year: 1880,
    location: "Los Angeles, California",
    description: "Portrait of a young woman",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=28SCCAB&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-fd20-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "15SCCAB",
    loc: "",
    uuid: "0c738550-c6e0-012f-192e-58d385a7bc34",
    artist: "Columbian Galleries",
    year: 1890,
    location: "New York, New York",
    description: "Portrait of woman wearing lace bodice",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=15SCCAB&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-1f5a-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1216630,
    loc: "",
    uuid: "05b81060-c6db-012f-61f5-3c075448cc4b",
    artist: "",
    year: 1916,
    location: "Philadelphia, Pensylvania",
    description: "Portrait of a woman in a striped dress",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1216630&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-9dcf-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1231552,
    loc: "",
    uuid: "7d97fa10-c6b4-012f-f6f8-58d385a7bc34",
    artist: "",
    year: 1914,
    location: "Washington D.C.",
    description: "Portrait of woman in white blouse with flowers in her hair",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1231552&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-1f59-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1216629,
    loc: "",
    uuid: "02aceb30-c6db-012f-1416-3c075448cc4b",
    artist: "",
    year: 1916,
    location: "Philadelphia, Pensylvania",
    description:
      "Portrait of a woman in a lace dress with large beaded necklace",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1216629&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-1f58-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1216628,
    loc: "",
    uuid: "ff795420-c6da-012f-42fe-3c075448cc4b",
    artist: "",
    year: 1916,
    location: "Philadelphia, Pensylvania",
    description:
      "Portrait of a woman in a dotted dress with large ribbon in her hair",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1216628&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-1f57-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1216627,
    loc: "",
    uuid: "fc5b6230-c6da-012f-732c-3c075448cc4b",
    artist: "",
    year: 1916,
    location: "Philadelphia, Pensylvania",
    description: "Portrait of a woman in a lace trimmed blouse",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1216627&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdc4-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "50SCCDV",
    loc: "",
    uuid: "c36352f0-c6ca-012f-be63-58d385a7bc34",
    artist: "Coss & Leach",
    year: "1860-1869",
    location: "Baltimore, Maryland",
    description: "Portrait of woman wearing patterned dress",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=50SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-1f55-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1216625,
    loc: "",
    uuid: "f6801e90-c6da-012f-b27b-3c075448cc4b",
    artist: "",
    year: 1916,
    location: "Philadelphia, Pensylvania",
    description: "Portrait of woman with earring, wearing a white blouse",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1216625&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdc9-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "54SCCDV",
    loc: "",
    uuid: "c50e9bc0-c6ca-012f-0fb3-58d385a7bc34",
    artist: "Bogardus, A.",
    year: "1860-1869",
    location: "New York, New York",
    description: "Portrait of a woman next to a tasseled curtain",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=54SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdea-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "46SCCDV",
    loc: "",
    uuid: "c1d0bf70-c6ca-012f-d041-58d385a7bc34",
    artist: "Sims' Photograph Gallery",
    year: "1860-1869",
    location: "Camden, New Jersey",
    description: "Portrait of a woman holding a handkerchief",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=46SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdbf-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "69SCCDV",
    loc: "",
    uuid: "cb759000-c6ca-012f-e6f0-58d385a7bc34",
    artist: "Hennigar, George W.",
    year: "1870-1879",
    location: "Middletown, Connecticut",
    description: "Portrait of a woman born in 1791 wearing a shawl",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: 33,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=69SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdc1-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "71SCCDV",
    loc: "",
    uuid: "cc40d870-c6ca-012f-7e86-58d385a7bc34",
    artist: "",
    year: "1870-1879",
    location: "",
    description: "Portrait of a woman with a rouched jacket",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: 33,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=71SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdc8-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "73SCCDV",
    loc: "",
    uuid: "cd375800-c6ca-012f-26fc-58d385a7bc34",
    artist: "Rice, M.P.",
    year: "1870-1879",
    location: "Washington D.C.",
    description: "Portrait of a woman wearing a lace bodice",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=73SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdc5-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "51SCCDV",
    loc: "",
    uuid: "c3d8dc10-c6ca-012f-aeff-58d385a7bc34",
    artist: "Durgan, J.O.",
    year: "1880-1889",
    location: "Norwich, Connecticut",
    description: "Portrait of a woman wearing a large scarf",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=51SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdec-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "48SCCDV",
    loc: "",
    uuid: "c29dcc90-c6ca-012f-36cb-58d385a7bc34",
    artist: "Gates, Thomas",
    year: "1880-1889",
    location: "New York, New York",
    description: "Portrait of a woman wearing a hat",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=48SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-a0f2-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1232152,
    loc: "",
    uuid: "888bf3f0-c6f5-012f-1b84-58d385a7bc34",
    artist: "",
    year: 1900,
    location: "Greenville, South Carolina",
    description: "Portrait of student of Industrial School in South Carolina",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 10,
    activityScore2: 24,
    activityScore3: 26,
    activityScore4: 32,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1232152&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/6a412f90-0bd1-0134-3942-00505686a51c",
    collection: "Schomburg Center for Research in Black Culture",
    id: 56805729,
    loc: "",
    uuid: "0f680030-0bd1-0134-7981-00505686a51c",
    artist: "",
    year: 1938,
    location: "",
    description: "Three women pose in costume",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 16,
    activityScore3: 17,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=56805729&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/6b6df820-0bd1-0134-c00f-00505686a51c",
    collection: "Schomburg Center for Research in Black Culture",
    id: 56805731,
    loc: "",
    uuid: "3b294dc0-0bd1-0134-5af7-00505686a51c",
    artist: "",
    year: "",
    location: "",
    description: "Chorus dancers pose for portrait on stage",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 16,
    activityScore3: 17,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=56805731&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e2-08ba-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "35SCJA",
    loc: "",
    uuid: "81d2f9f0-c6cd-012f-c9c6-58d385a7bc34",
    artist: "",
    year: 1914,
    location: "Syracuse, New York",
    description: "Portrait of women's war relief club",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 13,
    activityScore2: 26,
    activityScore3: 27,
    activityScore4: 28,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=35SCJA&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e2-fce1-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "09schaj",
    loc: "",
    uuid: "d6ecc580-c634-012f-d5be-58d385a7bc34",
    artist: "",
    year: "1900-1919",
    location: "",
    description: "Two women pretend to drive cutout automobile",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 13,
    activityScore2: 15,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=09schaj&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/82ce05c0-61eb-0132-17e2-58d385a7bbd0",
    collection: "Schomburg Center for Research in Black Culture",
    id: 5192959,
    loc: "",
    uuid: "c4d75af0-5c98-0132-a65c-58d385a7b928",
    artist: "Hansen, Austin",
    year: "1940-1949",
    location: "Harlem, New York",
    description: "Congregation of Abyssinian Baptist Church, Harlem",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 13,
    activityScore2: 21,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=5192959&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/db5d1860-61eb-0132-17b4-58d385a7bbd0",
    collection: "Schomburg Center for Research in Black Culture",
    id: 5192961,
    loc: "",
    uuid: "a1bf7710-5c9e-0132-5654-58d385a7bbd0",
    artist: "Hansen, Austin",
    year: "1950-1959",
    location: "Harlem, New York",
    description: "Congregation of Abyssinian Baptist Church, Harlem",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 13,
    activityScore2: 21,
    activityScore3: 26,
    activityScore4: 33,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=5192961&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-02f2-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1160078,
    loc: "",
    uuid: "881dba70-c6f5-012f-7306-58d385a7bc34",
    artist: "",
    year: 1902,
    location: "Greenville, South Carolina",
    description: "Portrait of dressing making students in South Carolina",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 20,
    activityScore2: 26,
    activityScore3: 32,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1160078&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cde6-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "42SCCDV",
    loc: "",
    uuid: "bfdb90e0-c6ca-012f-4327-58d385a7bc34",
    artist: "H.D. Garnes & Co.",
    year: "1860-1869",
    location: "Philadelphia, Pensylvania",
    description: "Portrait of two girls",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 22,
    activityScore2: 26,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=42SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/63d86849-25b8-d19b-e040-e00a18066120",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1694531,
    loc: "",
    uuid: "7e9f1900-c5f2-012f-49be-58d385a7bc34",
    artist: "",
    year: "1890-1899",
    location: "",
    description: "Portrait of five women",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1694531&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f8da-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260037,
    loc: "",
    uuid: "cd7e8a90-c612-012f-eb36-58d385a7bc34",
    artist: "Wolcott, Marion Post",
    year: 1940,
    location: "King & Anderson Plantation, Clarksdale, Mississippi",
    description: "Elderly woman stands on porch",
    landscape: 2,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 11,
    activityScore2: 12,
    activityScore3: 33,
    activityScore4: 36,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260037&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f975-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260196,
    loc: "",
    uuid: "bc350db0-c612-012f-2d1d-58d385a7bc34",
    artist: "Wolcott, Marion Post",
    year: 1940,
    location: "Thomastown, Louisiana",
    description: "Woman gardening outside her Louisiana home",
    landscape: 2,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 11,
    activityScore2: 26,
    activityScore3: 30,
    activityScore4: 35,
    activityScore5: 36,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260196&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f8d7-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260036,
    loc: "",
    uuid: "ccf7e050-c612-012f-104d-58d385a7bc34",
    artist: "Wolcott, Marion Post",
    year: 1939,
    location: "Delta Pine Company, Scott, Mississippi",
    description: "Woman walking past clinic in Scott, Mississippi",
    landscape: 2,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 23,
    activityScore2: 29,
    activityScore3: 33,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260036&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e3-d86c-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1615149,
    loc: "",
    uuid: "4e583df0-c6ed-012f-8e1d-3c075448cc4b",
    artist: "Lange, Dorothea",
    year: 1939,
    location: "Alabama",
    description: "Former slave outside dilapidated house",
    landscape: 2,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: 33,
    activityScore3: 35,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1615149&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f909-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260092,
    loc: "",
    uuid: "9ffe6860-c612-012f-f15f-58d385a7bc34",
    artist: "Wolcott, Marion Post",
    year: 1939,
    location: "River Farm, Georgia",
    description: "Woman and children gardening",
    landscape: 2,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 22,
    activityScore3: 30,
    activityScore4: 36,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260092&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f912-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260101,
    loc: "",
    uuid: "be1ef050-c612-012f-4df8-58d385a7bc34",
    artist: "Collier, John",
    year: "",
    location: "St. Mary's County, Maryland",
    description: "Three women talk while supervising chickens",
    landscape: 2,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 26,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260101&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f8d6-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260025,
    loc: "",
    uuid: "c7368bd0-c612-012f-d278-58d385a7bc34",
    artist: "Rothstein, Arthur",
    year: 1935,
    location: "Tupelo, Mississippi",
    description: "Tenant farmer holds her child",
    landscape: 2,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 22,
    activityScore3: 26,
    activityScore4: 38,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260025&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f8c3-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260031,
    loc: "",
    uuid: "caa2e390-c612-012f-1671-58d385a7bc34",
    artist: "Wolcott, Marion Post",
    year: 1940,
    location: "Hopson Plantation, Clarksdale, Mississippi",
    description: "Women walking next to cotton fields in Mississippi",
    landscape: 2,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 26,
    activityScore3: 36,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260031&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa11-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260348,
    loc: "",
    uuid: "933a8b50-c645-012f-b18a-58d385a7bc34",
    artist: "",
    year: 1943,
    location: "Des Moines, Iowa",
    description: "Women's Army Corp and Auxilary infantry drills",
    landscape: 2,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 26,
    activityScore3: 28,
    activityScore4: 35,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260348&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa12-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260349,
    loc: "",
    uuid: "93913a90-c645-012f-68e4-58d385a7bc34",
    artist: "",
    year: 1943,
    location: "Des Moines, Iowa",
    description: "Women's Army Corp and Auxilary gas mask drills",
    landscape: 2,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 26,
    activityScore3: 28,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260349&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa17-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260353,
    loc: "",
    uuid: "9568c630-c645-012f-2b09-58d385a7bc34",
    artist: "",
    year: "1939-1945",
    location: "England",
    description: "Army Nurses stand at atttention for inspection",
    landscape: 2,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 26,
    activityScore3: 28,
    activityScore4: 35,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260353&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f967-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260180,
    loc: "",
    uuid: "e981a9e0-c612-012f-d686-58d385a7bc34",
    artist: "Lee, Russell",
    year: 1939,
    location: "McIntosh County, Oklahoma",
    description: "Members of congregation sit outside church",
    landscape: 2,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 21,
    activityScore2: 26,
    activityScore3: 33,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260180&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-816c-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1211907,
    loc: "",
    uuid: "c5164790-c612-012f-9dd4-58d385a7bc34",
    artist: "Lange, Dorothea",
    year: 1937,
    location: "Clarksdale, Mississippi",
    description: "Young cotton hoer poses",
    landscape: 2,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 36,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1211907&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f8d3-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260054,
    loc: "",
    uuid: "d7d11520-c612-012f-c7fb-58d385a7bc34",
    artist: "Wolcott, Marion Post",
    year: 1940,
    location: "Natchez, Mississippi",
    description: "Woman carrying bundle on her head",
    landscape: 2,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 11,
    activityScore2: 26,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260054&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-7c20-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1215877,
    loc: "",
    uuid: "3cd72a30-c6cc-012f-9c3e-58d385a7bc34",
    artist: "",
    year: 1909,
    location: "",
    description: "Portrait of elderly woman with wooden leg",
    landscape: 2,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 19,
    activityScore2: 26,
    activityScore3: 33,
    activityScore4: 35,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1215877&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-1a14-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1168435,
    loc: "",
    uuid: "3676f200-c6cc-012f-9d59-58d385a7bc34",
    artist: "",
    year: 1909,
    location: "",
    description: "Portrait of a woman in a cotton field",
    landscape: 2,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: 26,
    activityScore3: 38,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1168435&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-a95f-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1234612,
    loc: "",
    uuid: "4b9c67b0-c62b-012f-f88d-58d385a7bc34",
    artist: "",
    year: 1926,
    location: "",
    description: "Portrait of a woman in overgrown field",
    landscape: 2,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: 36,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1234612&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-a95e-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1234611,
    loc: "",
    uuid: "4b4ce8c0-c62b-012f-fb10-58d385a7bc34",
    artist: "",
    year: 1926,
    location: "",
    description: "Portrait of a woman with braided hair",
    landscape: 2,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1234611&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e3-d86b-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1615148,
    loc: "",
    uuid: "4a979490-c6ed-012f-b5c1-3c075448cc4b",
    artist: "Lange, Dorothea",
    year: 1939,
    location: "Alabama",
    description: "Portrait of former slave in Alabama",
    landscape: 2,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: 33,
    activityScore3: 36,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1615148&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fa16-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260352,
    loc: "",
    uuid: "95016b80-c645-012f-d006-58d385a7bc34",
    artist: "",
    year: "1939-1945",
    location: "Liberia",
    description: "Women's Army Auxilary Corp line up for review in Libera",
    landscape: 2,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 26,
    activityScore3: 28,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260352&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e2-fce2-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "08schaj",
    loc: "",
    uuid: "d72abc60-c634-012f-4c27-58d385a7bc34",
    artist: "",
    year: "1890-1909",
    location: "",
    description: "Woman poses on porch with two white children",
    landscape: 2,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 12,
    activityScore3: 22,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=08schaj&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-a95c-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1234610,
    loc: "",
    uuid: "4b123220-c62b-012f-9696-58d385a7bc34",
    artist: "",
    year: 1926,
    location: "",
    description: "Portrait of three elderly women wearing mojo talismans",
    landscape: 2,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 21,
    activityScore2: 26,
    activityScore3: 33,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1234610&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-8170-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1211911,
    loc: "",
    uuid: "b64f6860-c612-012f-a528-58d385a7bc34",
    artist: "Lee, Russell",
    year: 1939,
    location: "Hammond, Louisiana",
    description: "Woman cooking",
    landscape: 2,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 11,
    activityScore2: 14,
    activityScore3: 30,
    activityScore4: 35,
    activityScore5: 38,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1211911&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47de-8719-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1212132,
    loc: "",
    uuid: "b264ad50-c612-012f-b74a-58d385a7bc34",
    artist: "Lee, Russell",
    year: 1939,
    location: "Transylvania, Louisiana",
    description: "Woman homeschools her two children",
    landscape: 2,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 11,
    activityScore3: 14,
    activityScore4: 22,
    activityScore5: 35,
    activityScore6: 38,
    imageLink: "https://images.nypl.org/index.php?id=1212132&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f8a7-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260007,
    loc: "",
    uuid: "8156d3b0-c612-012f-1cac-58d385a7bc34",
    artist: "Wolcott, Marion Post",
    year: 1939,
    location: "Gee's Bend, Alabama",
    description: "Elderly woman reads aloud to class",
    landscape: 2,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 22,
    activityScore3: 26,
    activityScore4: 33,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260007&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f8d1-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260053,
    loc: "",
    uuid: "d73af060-c612-012f-d18d-58d385a7bc34",
    artist: "Wolcott, Marion Post",
    year: 1939,
    location: "Milestone, Mississippi",
    description: "Milestone Plantation school students and teacher",
    landscape: 2,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 9,
    activityScore2: 12,
    activityScore3: 13,
    activityScore4: 22,
    activityScore5: 26,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260053&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f8cd-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260049,
    loc: "",
    uuid: "d44d72e0-c612-012f-5226-58d385a7bc34",
    artist: "Wolcott, Marion Post",
    year: 1940,
    location: "Bayou Bourbeaux Plantation, Natchitoches Parish, Louisiana",
    description: "Girl and baby sitting on a bed",
    landscape: 2,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 14,
    activityScore3: 22,
    activityScore4: 26,
    activityScore5: 35,
    activityScore6: 36,
    imageLink: "https://images.nypl.org/index.php?id=1260049&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f973-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260195,
    loc: "",
    uuid: "bba57800-c612-012f-909d-58d385a7bc34",
    artist: "Wolcott, Marion Post",
    year: 1940,
    location: "Thomastown, Louisiana",
    description:
      "Women and children playing bingo after La Delta Project meeting",
    landscape: 2,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 15,
    activityScore3: 22,
    activityScore4: 27,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260195&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f8ff-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260078,
    loc: "",
    uuid: "fdff69f0-c612-012f-130c-58d385a7bc34",
    artist: "Delano, Jack",
    year: 1941,
    location: "Caroline County, Virginia",
    description: "Woman and children preparing to move",
    landscape: 2,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 14,
    activityScore3: 22,
    activityScore4: 26,
    activityScore5: 35,
    activityScore6: 37,
    imageLink: "https://images.nypl.org/index.php?id=1260078&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-fd14-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1261011,
    loc: "",
    uuid: "9d5a4ac0-c6b7-012f-27aa-58d385a7bc34",
    artist: "",
    year: "1898-1955",
    location: "Howard's Orphanage, Kings Park, New York",
    description: "Girls learning how to bake at Howard's Vocational school",
    landscape: 2,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 22,
    activityScore3: 26,
    activityScore4: 30,
    activityScore5: 32,
    activityScore6: 35,
    imageLink: "https://images.nypl.org/index.php?id=1261011&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f8e8-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260068,
    loc: "",
    uuid: "98492780-c612-012f-c1b4-58d385a7bc34",
    artist: "Delano, Jack",
    year: 1941,
    location: "Heard County, Georgia",
    description: "Congregation sitting in pews in Heard County, George",
    landscape: 2,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 13,
    activityScore2: 21,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1260068&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-a083-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1232075,
    loc: "",
    uuid: "040afdf0-c6bc-012f-30c3-58d385a7bc34",
    artist: "",
    year: 1908,
    location: "Clark County, Mississippi",
    description: "Portrait of a missionary student at Clark University",
    landscape: 2,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 9,
    activityScore2: 21,
    activityScore3: 26,
    activityScore4: 39,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=1232075&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47df-f89f-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: 1260006,
    loc: "",
    uuid: "834c4410-c612-012f-6318-58d385a7bc34",
    artist: "Delano, Jack",
    year: 1941,
    location: "Greensboro, Alabama",
    description: "Former slave poses in her home",
    landscape: 2,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 11,
    activityScore2: 14,
    activityScore3: 26,
    activityScore4: 33,
    activityScore5: 35,
    activityScore6: 39,
    imageLink: "https://images.nypl.org/index.php?id=1260006&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdeb-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "47SCCDV",
    loc: "",
    uuid: "c22ebb50-c6ca-012f-d26c-58d385a7bc34",
    artist: "Saurman, Thomas M.",
    year: 1870,
    location: "Norristown, Pennsylvania",
    description: "Portrait of a woman wearing a headwrap",
    landscape: 2,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: 33,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=47SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cde9-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "45SCCDV",
    loc: "",
    uuid: "c1665da0-c6ca-012f-a4a4-58d385a7bc34",
    artist: "Insley, H.A.",
    year: 1880,
    location: "Nyack, New York",
    description: "Portrait of woman wearing gloves and leaning on fence",
    landscape: 2,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=45SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cda9-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "15SCCDV",
    loc: "",
    uuid: "b4beca60-c6ca-012f-0750-58d385a7bc34",
    artist: "Richmond Photograph Co.",
    year: "1880-1889",
    location: "Richmond, Virginia",
    description: "Portrait of a woman",
    landscape: 2,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=15SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdca-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "55SCCDV",
    loc: "",
    uuid: "c56a6460-c6ca-012f-0397-58d385a7bc34",
    artist: "Hunt, A.T.",
    year: "1880-1889",
    location: "Morristown, Tennessee",
    description: "Portrait of a woman with ribboned neck",
    landscape: 2,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=55SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdcb-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "56SCCDV",
    loc: "",
    uuid: "c5c96dd0-c6ca-012f-b0c4-58d385a7bc34",
    artist: "Insley, H.A.",
    year: "1880-1889",
    location: "Nyack, New York",
    description: "Portrait of a woman in a buttoned bodice",
    landscape: 2,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=56SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdcf-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "60SCCDV",
    loc: "",
    uuid: "c7643840-c6ca-012f-ba33-58d385a7bc34",
    artist: "",
    year: "1880-1889",
    location: "York, Pennsylvania",
    description: "Portrait of a woman wearing a chain necklace",
    landscape: 2,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=60SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdcc-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "57SCCDV",
    loc: "",
    uuid: "c6289100-c6ca-012f-27ce-58d385a7bc34",
    artist: "Bean, L.V.",
    year: "1880-1889",
    location: "Sioux Falls, South Dakota",
    description: "Portrait of a woman in velvet",
    landscape: 2,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=57SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e1-cdd6-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "74SCCDV",
    loc: "",
    uuid: "cd974a20-c6ca-012f-8f70-58d385a7bc34",
    artist: "Richmond Photograph Co.",
    year: "1880-1889",
    location: "Richmond, Virginia",
    description: "Portrait of a woman wearing a lace collar",
    landscape: 2,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=74SCCDV&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4de5-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439931,
    loc: "",
    uuid: "3a5ee550-c609-012f-c9a9-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Woman in mob cap sorts chocolates into boxes",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: 30,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439931&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4ddb-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439922,
    loc: "",
    uuid: "367c9c80-c609-012f-d64b-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Smiling woman wearing white cloth cap",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: "",
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439922&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4dda-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439921,
    loc: "",
    uuid: "36303590-c609-012f-ba24-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Woman wearing white cap threads knitting reel",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 20,
    activityScore4: 24,
    activityScore5: 26,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439921&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4dd9-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439920,
    loc: "",
    uuid: "35d48380-c609-012f-8bbc-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907-1933",
    location: "New York, New York",
    description: "Woman wearing bandana threads industrial spinner",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439920&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4dd8-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439919,
    loc: "",
    uuid: "35795990-c609-012f-723d-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Portrait of a woman in a spinning factory",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439919&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4dd7-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439918,
    loc: "",
    uuid: "351384f0-c609-012f-f827-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Woman sharpening tools in factory",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439918&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4d42-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 464381,
    loc: "",
    uuid: "e1f396e0-c608-012f-52b6-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: 1910,
    location: "New England",
    description: "Young girl poses in front of spinning machine",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 22,
    activityScore4: 24,
    activityScore5: 26,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=464381&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4cc6-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 464471,
    loc: "",
    uuid: "f895d2d0-c608-012f-a9b8-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: 1930,
    location: "Mount Vernon, New York",
    description: "15 year old girl bottling hair tonic",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 22,
    activityScore4: 24,
    activityScore5: 26,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=464471&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4cc0-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 464465,
    loc: "",
    uuid: "f71f6d30-c608-012f-bf53-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: 1913,
    location: "New York, New York",
    description: "14 year old girl working in paper box factory",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 22,
    activityScore4: 24,
    activityScore5: 26,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=464465&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/87ac1d57-b1e6-9892-e040-e00a180672f0",
    collection: "Jerome Robbins Dance Division",
    id: "psnypl_dan_1656",
    loc: "",
    uuid: "1615a610-c5fe-012f-d8f1-58d385a7bc34",
    artist: "Melton, Frederick",
    year: "1937- 1940",
    location: "New York, New York",
    description:
      "Girls and instructor in ballet class at the NYC School of Ballet",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 16,
    activityScore2: 22,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=psnypl_dan_1656&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/42a98400-fd5d-0135-4b24-4b2548c1d655",
    collection: "Billy Rose Theatre Division",
    id: 57460725,
    loc: "",
    uuid: "4200bde0-fd5d-0135-f51d-391ea79cf2a1",
    artist: "White Studios, New York",
    year: "1922- 1923",
    location: "New York, New York",
    description:
      "Women dressed as gypsies pose for production of Chauve-Souris",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 17,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=57460725&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/e88da080-e37d-0135-e39c-006b9fdee980",
    collection: "Billy Rose Theatre Division",
    id: 57486035,
    loc: "",
    uuid: "e7c3f930-e37d-0135-a59e-371047bafc62",
    artist: "Keystone Pictures, New York",
    year: 1943,
    location: "New York, New York",
    description: 'Original cast members of "Oklahoma!" dance backstage',
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 17,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=57486035&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4de9-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439935,
    loc: "",
    uuid: "3be28570-c609-012f-33b7-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "",
    description: "Young girl picking herbs in a field",
    landscape: 2,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 11,
    activityScore2: 22,
    activityScore3: 26,
    activityScore4: 36,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439935&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/4b75e430-88d8-0134-9e9f-00505686a51c",
    collection: "Billy Rose Theatre Division",
    id: 56930409,
    loc: "",
    uuid: "4ad60050-88d8-0134-283d-00505686a51c",
    artist: "",
    year: 1958,
    location: "New York, New York",
    description: 'West Side Story" actresses celebrate backstage',
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 17,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=56930409&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e2-fcdf-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "11schaj",
    loc: "",
    uuid: "d663f1c0-c634-012f-a1c0-58d385a7bc34",
    artist: "",
    year: "",
    location: "",
    description: "Portrait of a seated older woman in a striped dress",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 26,
    activityScore2: 33,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=11schaj&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4df2-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439938,
    loc: "",
    uuid: "34b51960-c609-012f-4cf6-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Woman operating a metal press",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 24,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439938&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4ddf-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439926,
    loc: "",
    uuid: "382adda0-c609-012f-1253-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Women sewing in workroom",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 24,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439926&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4dde-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439925,
    loc: "",
    uuid: "37a9f9b0-c609-012f-06a1-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Woman finishing garment",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 26,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439925&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4de7-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439933,
    loc: "",
    uuid: "3b1b3810-c609-012f-a238-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Two women sort chocolates in a factory",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: 30,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439933&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4ddc-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439923,
    loc: "",
    uuid: "36eb72b0-c609-012f-3ee4-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Woman arrives at her place of work",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 23,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439923&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47e2-fcd6-a3d9-e040-e00a18064a99",
    collection: "Schomburg Center for Research in Black Culture",
    id: "02schaj",
    loc: "",
    uuid: "d37aad60-c634-012f-40ea-58d385a7bc34",
    artist: "",
    year: "",
    location: "",
    description: "Young woman in elaborately beaded costume",
    landscape: 1,
    locationScore: 4,
    styleScore: 6,
    peopleScore: 7,
    activityScore: 16,
    activityScore2: 26,
    activityScore3: "",
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=02schaj&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4e06-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439957,
    loc: "",
    uuid: "26a75480-c609-012f-74ba-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Mother with her child delievers home-made flowers",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 12,
    activityScore3: 20,
    activityScore4: 22,
    activityScore5: 23,
    activityScore6: 26,
    imageLink: "https://images.nypl.org/index.php?id=439957&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4e08-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439959,
    loc: "",
    uuid: "2775c760-c609-012f-3442-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "Canada",
    description: "Masked woman fills mortar shells",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 25,
    activityScore4: 26,
    activityScore5: 28,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439959&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4e05-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439956,
    loc: "",
    uuid: "264c2830-c609-012f-c6e2-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: 1907,
    location: "New York, New York",
    description: "Girl delievers home-made flowers on West 3rd Street",
    landscape: 1,
    locationScore: 3,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 22,
    activityScore4: 23,
    activityScore5: 26,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439956&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4e04-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439955,
    loc: "",
    uuid: "25dd0c30-c609-012f-39ad-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Woman with children carries home flower making materials",
    landscape: 1,
    locationScore: 3,
    styleScore: 6,
    peopleScore: 8,
    activityScore: 11,
    activityScore2: 12,
    activityScore3: 20,
    activityScore4: 22,
    activityScore5: 23,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439955&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4e03-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439954,
    loc: "",
    uuid: "257bdc70-c609-012f-143e-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Women branch together artificial flowers",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: 33,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439954&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4e00-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439952,
    loc: "",
    uuid: "244202c0-c609-012f-797d-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Young women working at a table in artificial flower factory",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439952&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4dff-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439951,
    loc: "",
    uuid: "23d16060-c609-012f-bf3f-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Two women working on artificial flowers",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439951&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4dfd-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439949,
    loc: "",
    uuid: "22f79880-c609-012f-2550-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Women pressing petals for artificial flowers",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 20,
    activityScore4: 24,
    activityScore5: 26,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439949&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4dfe-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439950,
    loc: "",
    uuid: "2372ded0-c609-012f-3602-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Women create foliage for artificial flowers",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439950&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4dfc-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439948,
    loc: "",
    uuid: "22a69ad0-c609-012f-0b1f-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Women assemble artificial flowers",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439948&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4dfb-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439947,
    loc: "",
    uuid: "2238de50-c609-012f-637e-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Two women assemble artificial roses",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439947&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4dfa-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439946,
    loc: "",
    uuid: "21d2a5b0-c609-012f-5daa-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Women assemble artificial roses",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 20,
    activityScore4: 24,
    activityScore5: 26,
    activityScore6: 33,
    imageLink: "https://images.nypl.org/index.php?id=439946&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4df9-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439945,
    loc: "",
    uuid: "21785d70-c609-012f-6346-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Two women assemble artificial roses",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439945&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4df7-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439943,
    loc: "",
    uuid: "20b44b10-c609-012f-6fd9-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Woman uses goffer iron to press artificial flower petals",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 10,
    activityScore2: 12,
    activityScore3: 20,
    activityScore4: 24,
    activityScore5: 26,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439943&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4df6-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439942,
    loc: "",
    uuid: "204d78e0-c609-012f-47c7-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Women prepare artificial rose petals for joining",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439942&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4df5-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439941,
    loc: "",
    uuid: "1ff3cb40-c609-012f-b650-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Women at a table assemble artificial roses",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 8,
    activityScore: 12,
    activityScore2: 20,
    activityScore3: 24,
    activityScore4: 26,
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439941&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4deb-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439937,
    loc: "",
    uuid: "3cb810c0-c609-012f-229e-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "New York, New York",
    description: "Elderly woman punches tickets",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 12,
    activityScore2: 24,
    activityScore3: 33,
    activityScore4: "",
    activityScore5: "",
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439937&t=w",
  },
  {
    permalink:
      "https://digitalcollections.nypl.org/items/510d47d9-4dea-a3d9-e040-e00a18064a99",
    collection:
      "The Miriam and Ira D. Wallach Divison of Art, Prints and Photographs",
    id: 439936,
    loc: "",
    uuid: "3c584b40-c609-012f-1df5-58d385a7bc34",
    artist: "Hine, Lewis Wickes",
    year: "1907- 1933",
    location: "",
    description: "Girl draws two zebras using charcoal",
    landscape: 1,
    locationScore: 4,
    styleScore: 5,
    peopleScore: 7,
    activityScore: 14,
    activityScore2: 15,
    activityScore3: 22,
    activityScore4: 26,
    activityScore5: 40,
    activityScore6: "",
    imageLink: "https://images.nypl.org/index.php?id=439936&t=w",
  },
];
